import { APICore } from "./apiCore";
const api = new APICore();

const getSprintData = (params) => {
    const baseUrl = `/sprint/list`;
    return api.get(`${baseUrl}`, params);
}

const getSprintDataById = (params) => {
    const baseUrl = `/sprint/get`;
    return api.get(`${baseUrl}`, params);
};

const addSprintData = (params) => {
    console.log('Para<s: ', params);
    const baseUrl = `/sprint/add`;
    return api.create(`${baseUrl}`, params);
};

const updateSprintData = (params) => {
    const baseUrl = `/sprint/update`;
    return api.update(`${baseUrl}`, params);
};

const deleteSprintData = (id) => {
    const baseUrl = `/sprint/delete/${id}`;
    return api.delete(`${baseUrl}`);
};

const getSprintReportData = (params) => {
    const baseUrl = `sprint/count`;
    return api.get(`${baseUrl}`, params);
};

export { getSprintData, getSprintDataById, addSprintData, updateSprintData, deleteSprintData, getSprintReportData }